import {PLATFORM_AREA, RIA_COMPONENT} from '@advisor/util/constants';

export default [
  {
    // Advisor Profile
    path: '/advisor/profile',
    name: 'Profile',
    component: () => import('@advisor/components/user/profile/Tabs'),
    meta: {
      platformArea: PLATFORM_AREA.COMMON,
      riaComponent: RIA_COMPONENT.DASHBOARD,
    },
  },
];
